import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './ValidatableField.css';
import icons from '../../assets/icons';

class ValidatableField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valid: true
    };
  }

  static get propTypes() {
    return {
      label: PropTypes.string,
      validationMessage: PropTypes.string,
      className: PropTypes.string,
      editing: PropTypes.bool,
      editWarning: PropTypes.string,
      errorMessage: PropTypes.string,
      toolTip: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      validationMessage: 'Invalid Field'
    };
  }

  clearErrors() {
    this.setState({ valid: true });
  }

  render() {
    const { label, className, toolTip } = this.props;

    return (
      <div className={classnames('ValidatableField', className)} title={toolTip}>
        <label
          className={classnames('ValidatableField-label', { show: this.showLabel() })}
        >{label}</label>
        {this.renderControl()}
        {this.renderMessage()}
      </div>
    );
  }

  renderMessage() {
    const { editing, editWarning, errorMessage, validationMessage, required } = this.props;
    const { valid } = this.state;

    if (!validationMessage && !editWarning && !errorMessage) {
      return null;
    }
    const error = (!valid && validationMessage && required) || errorMessage;
    const show = error || (editing && editWarning);

    let message = validationMessage;
    if (errorMessage) {
      message = errorMessage;
    } else if (!valid && validationMessage) {
      message = editing ? validationMessage : null;
    } else if (editing && editWarning) {
      message = editWarning;
    }

    return (
      <div className={classnames('ValidatableField-message', { show, error })}>
        <span>{message}</span>
        {error && <img src={icons.red.warning} alt="warning" />}
      </div>
    );
  }

  renderControl() {
    throw new Error('Not implemented');
  }

  showLabel() {
    return true;
  }

  validate() {
    return null;
  }

  setValid(valid) {
    this.setState({ valid });
  }
}

export default ValidatableField;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/ValidatableField.js